import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Home from "./views/Home";
import Login from "./views/Login";
import e403 from "./views/403";

Vue.use(Router);

var unfilteredSites = [
    "/",
    "/403",
    "/404",
    "/login",
    "/logout",
    "/howto",
    "/changelog",
    "/settings",
    "/forget_password"
];

var routes = [
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter(to, from, next) {
            store.dispatch('logout').then(() => {
                fetch("/api-logout");
                return next('/login');
            })
        }
    },
    {
        path: "/forget_password",
        name: "forget-password",
        component: () => import("./views/ForgetPassword")
    },
    {
        path: "/403",
        name: "403",
        component: e403,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mitglieder",
        name: "mitglieder",
        component: () => import("./views/Mitglieder"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mitglieder/statistik",
        name: "mitgliederstatistik",
        component: () => import("./views/Mitgliederstatistik"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/mitglieder/:id",
        name: "mitglieder-detail",
        component: () => import("./views/MitgliederDetail"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/status",
        name: "status",
        component: () => import("./views/Status"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/statuserweiterung",
        name: "statuserweiterung",
        component: () => import("./views/Statuserweiterung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/probenplan",
        name: "probenplan",
        component: () => import("./views/Probenplan/Probenplan"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/probentyp",
        name: "probentyp",
        component: () => import("./views/Probentyp"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/werke",
        name: "werke",
        component: () => import("./views/Werke"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/proben_stammdaten",
        name: "proben_stammdaten",
        component: () => import("./views/ProbenStammdaten"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/anwesenheitsverwaltung_neu",
        name: "anwesenheitsverwaltung_neu",
        component: () =>
            import("./views/AnwesenheitsverwaltungNeu/Anwesenheitsverwaltung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/abrechnung_gast",
        name: "abrechnung_gast",
        component: () => import("./views/AbrechnungGast/AbrechnungGast"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/anwesenheitsstatisik",
        name: "anwesenheitsstatisik",
        component: () => import("./views/Anwesenheitsstatisik"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu",
        name: "fibu",
        component: () => import("./views/Fibu"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/benutzerverwaltung/user",
        name: "benutzerverwaltung",
        component: () =>
            import("./views/Benutzerverwaltung/Benutzerverwaltung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/benutzerverwaltung/groups",
        name: "benutzergruppen",
        component: () => import("./views/Benutzergruppen"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/singpause",
        name: "singpause",
        component: () => import("./views/SingPause"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/migration",
        name: "migration",
        component: () => import("./views/Migration"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/settings",
        name: "settings",
        component: () => import("./views/Settings"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/changelog",
        name: "changelog",
        component: () => import("./views/Changelog"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/howto",
        name: "howto",
        component: () => import("./views/Howto/Howto"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notenverwaltung/noten",
        name: "noten",
        component: () => import("./views/Notenverwaltung/Noten/Noten"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notenverwaltung/notentransfer/sv",
        name: "notentransfersv",
        component: () =>
            import("./views/Notenverwaltung/NotentransferSV/NotentransferSV"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notenverwaltung/notentransfer/mitglieder",
        name: "notentransfermitglieder",
        component: () =>
            import(
                "./views/Notenverwaltung/NotentransferMitglieder/NotentransferMitglieder"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/notenverwaltung/notentransactions",
        name: "notentransactionlist",
        component: () =>
            import(
                "./views/Notenverwaltung/NotenTransactionList/NotenTransactionList"
            ),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/singpause/list/singleiter",
        name: "singleiterlist",
        component: () => import("./views/SingPause/Lists/SingleiterList"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/singpause/list/schulen",
        name: "schulenlist",
        component: () => import("./views/SingPause/Lists/SchulenList"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/buchungskonto",
        name: "buchungskonto",
        component: () => import("./views/FiBu/Buchungskonto"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/finanzkonto",
        name: "finanzkonto",
        component: () => import("./views/FiBu/Finanzkonto"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/zuschusskonto",
        name: "zuschusskonto",
        component: () => import("./views/FiBu/Zuschusskonto"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/ruecklagenkonto",
        name: "ruecklagenkonto",
        component: () => import("./views/FiBu/Ruecklagenkonto"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/group",
        name: "group",
        component: () => import("./views/FiBu/Group"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/category",
        name: "category",
        component: () => import("./views/FiBu/Category"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/status_stamm",
        name: "status_stamm",
        component: () => import("./views/FiBu/StatusStammdaten"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/verwendungszweck",
        name: "verwendungszweck",
        component: () => import("./views/FiBu/Verwendungszweck"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/buchung/:id/gruppierungskonten",
        name: "buchung-gruppierungskonten",
        component: () => import("./views/FiBu/BuchungGruppierungskonten"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/offene_posten",
        name: "offene_posten",
        component: () => import("./views/FiBu/OffenePosten"),
        meta: {
            requiresAuth: true
        }
    },
    {
      path: "/fibu/offene_posten/:id",
      name: "offene_posten-detail",
      component: () => import("./views/FiBu/OffenePostenDetail.vue"),
      meta: {
          requiresAuth: true
      }
    },
    {
        path: "/fibu/offene_posten/:id/buchung",
        name: "offene_posten-buchung",
        component: () => import("./views/FiBu/OffenePostenBuchung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/offene_posten/:id/guthaben",
        name: "offene_posten-guthaben",
        component: () => import("./components/FiBuOPGuthaben/FiBuOPGuthaben"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/susa",
        name: "susa",
        component: () => import("./views/FiBu/Susa"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/spendenquittung",
        name: "spendenquittung",
        component: () => import("./views/FiBu/Spendenquittung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/buchungsstapel/:id",
        name: "buchungsstapel-anlegen",
        component: () => import("./components/FiBuNewBuchungsstapel/FiBuNewBuchungsstapel"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/buchungsvorlage/new/buchungsstapel/:id",
        name: "buchungsvorlage",
        component: () => import("./components/FiBuBuchungsvorlage/FiBuBuchungsvorlage"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/buchungsvorlage/:id/buchungsstapel/:bsid",
        name: "buchungsvorlage-bearbeiten",
        component: () => import("./components/FiBuBuchungsvorlage/FiBuBuchungsvorlage"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/mitgliedsbeitraege",
        name: "mitgliedsbeitraege",
        component: () => import("./views/FiBu/Mitgliedsbeitraege"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/mitgliedsbeitraege/verwalten",
        name: "mitgliedsbeitraege-verwalten",
        component: () => import("./components/FiBuMitgliedsbeitraegeVerwaltung/FibuMitgliedsbeitraegeVerwaltung"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/mitgliedsbeitraege/verwalten/:id",
        name: "mitgliedsbeitraege-anlegen-bearbeiten",
        component: () => import("./components/FiBuMitgliederbeitraegeDetail/FiBuMitgliederbeitaegeDetail"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/mitgliedsbeitraege/erstellen",
        name: "mitgliedsbeitraege-erstellen",
        component: () => import("./components/FiBuMitgliedsbeitraegeUebersicht/FiBuMitgliedsBeitraegeUebersicht"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/mitgliedsbeitraege/drucken",
        name: "mitgliedsbeitraege-drucken",
        component: () => import("./components/FiBuMitgliedsbeitraegeDruck/FiBuMitgliedsbeitraegeDruck"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/fibu/kontenblaetter",
        name: "kontenblaetter",
        component: () => import("./views/FiBu/Kontenblatt"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/404",
        name: "notfound",
        component: () => import("./views/NotFound")
    },
    {
        path: "*",
        redirect: "/404"
    }
];

var router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routes
});

router.beforeEach((to, from, next) => {
    var menu = store.getters.getMenu;
    var menuFlat = [];
    Object.values(menu).forEach(items => {
        return (menuFlat = menuFlat.concat(items));
    });
    if (
        to.matched.some(record => record.meta.requiresAuth) &&
        !store.getters.getAuth.isAuthentificated
    ) {
        next("/login");
    } else if (
        !menuFlat.some(
            item => item.slug === to.path || item.slug === to.matched[0].path
        ) &&
        !unfilteredSites.some(item => item === to.path)
    ) {
        next("/403");
    } else {
        store.dispatch("currentPage", to);
        next();
    }
});

export default router;
